import { createReducer, on } from '@ngrx/store';

import {
	deleteProject,
	deleteProjectFail,
	deleteProjectSuccess,
	fetchIsProjectDeletableSuccess,
	fetchProjectElementsSuccess,
	fetchProjectsSuccess,
	fetchProjectsWithViewSettingsSuccess,
	getProjectMembers,
	getProjectMembersSuccess,
	initProjects,
	modifySearchTerm,
	orphanProjectsCheckSuccess,
	refreshProjects,
	resetProjectAfterDeletePopupClose,
	switchProjectsViewMode,
} from './project.actions';
import { ProjectSliceState } from './project.state';

export const projectOriginalReducer = createReducer<ProjectSliceState>(
	new ProjectSliceState(),
	on(initProjects, refreshProjects, (state) => state.setLoading(true)),
	on(fetchProjectsSuccess, (state, action) =>
		state.setLoading(false).setProjects(action.projectList)
	),
	on(switchProjectsViewMode, (state, action) =>
		state.setProjectsViewMode(action.viewMode)
	),
	on(modifySearchTerm, (state, action) =>
		state.setProjectsSearchTerm(action.term)
	),
	on(fetchProjectsWithViewSettingsSuccess, (state, action) =>
		state
			.setProjects(action.projectList)
			.setProjectsSearchTerm(action.term)
			.setProjectsViewMode(action.viewMode)
	),
	on(orphanProjectsCheckSuccess, (state, action) =>
		state.setOrphanProjects(action.hasOrphanProjects)
	),
	on(getProjectMembers, (state) => state.setLoadingMembers(true)),

	on(getProjectMembersSuccess, (state, action) =>
		state
			.updateProjectsWithMembers(action.projectId, action.members)
			.setLoadingMembers(false)
	),
	on(fetchProjectElementsSuccess, (state, action) =>
		state.updateProjectsWithCriticalAndDcElements(
			action.id,
			action.elements,
			action.isCritical
		)
	),
	on(fetchIsProjectDeletableSuccess, (state, action) =>
		state.updateProjectsWithDeletable(action.id, action.isDeletable)
	),
	on(deleteProject, (state) => state.setDeletingInProgress(true)),
	on(deleteProjectSuccess, (state) => state.setDeletingInProgress(false)),
	on(deleteProjectFail, (state) => state.setDeletingInProgress(false)),
	on(resetProjectAfterDeletePopupClose, (state, action) =>
		state.resetProject(action.id)
	)
);
